import {
  Box,
  Tab,
  Tabs,
  Typography
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import AddSkillBookTemplate from "../../routes/Profile/AddSkillBook/AddSkillBookTemplate";
import AddSkillBookExternalTrainingTemplate from "../../routes/Profile/ExternalTrainingAddSkillbook/AddSkillBookExternalTrainingTemplate";
import { AddSkillBookTemplateProps } from "routes/Profile/ExternalTrainingAddSkillbook/AddSkillBook.types";

export const ExternalTrainingModal: React.FC<AddSkillBookTemplateProps> = ({
  closeModal
}) => {
  const [tabIndex, setTabIndex] = useState(0);
  const theme = useTheme();
  const { t } = useTranslation();

  const handleChange = (_: unknown, newValue: number) => {
    setTabIndex(newValue);
  };

  return (
    <>
      { /* Contenitore delle Tabs */ }
      <Box
        sx={ {
          flexDirection: "column",
          display: "flex",
          justifyContent: "space-between",
          maxHeight: "495px",
          overflowY: "auto",
          width: "100%",
          color: theme.customColors.exploreCardText,
          borderBottom: theme.customColors.border,
          pb: 1
        } }
      >
        <Tabs
          value={ tabIndex }
          onChange={ handleChange }
          variant="fullWidth"
          centered
          TabIndicatorProps={ {
            style: {
              backgroundColor: theme.customColors.textMandatory,
              height: 3
            }
          } }
          sx={ {
            width: "100%",
            borderBottom: "1px solid #333"
          } }
        >
          <Tab
            label={ t("external_training") }
            sx={ {
              width: "100%",
              flex: 1,
              textAlign: "center",
              color:
                tabIndex === 0
                  ? `${theme.customColors.textMandatory} !important`
                  : `${theme.customColors.exploreCardText} !important`,
              fontSize: 20
            } }
          />
          <Tab
            label={ t("Consuntivation") }
            sx={ {
              width: "100%",
              flex: 1,
              textAlign: "center",
              color:
                tabIndex === 1
                  ? `${theme.customColors.textMandatory} !important`
                  : `${theme.customColors.exploreCardText} !important`,
              fontSize: 20
            } }
          />
        </Tabs>
      </Box>

      { /* Contenitore dei contenuti dei Tab */ }
      <Box
        sx={ {
          flexDirection: "column",
          justifyContent: "center",
          maxHeight: "495px",
          overflowY: "auto",
          color: theme.customColors.exploreCardText,
          scrollbarWidth: "none",
          "&::-webkit-scrollbar": { display: "none" },
          "& .MuiTypography-root, .MuiInputLabel-root,.MuiInputBase-input, span, svg, path":{
            color: `${theme.customColors.exploreCardText} !important`,
            fill: `${theme.customColors.exploreCardText} !important`
          }
        } }
      >
        { tabIndex === 0 && (
          <Box>
            <Typography
              variant="h6"
              color={ theme.customColors.exploreCardText }
              sx={ { marginRight: "auto", mb: 2 } }
            >
              { t("request_training_field") }
            </Typography>
            <AddSkillBookExternalTrainingTemplate closeModal={ closeModal } />
          </Box>
        ) }
        { tabIndex === 1 && (
          <Box>
            <Typography
              variant="h6"
              color={ theme.customColors.exploreCardText }
              sx={ { marginRight: "auto", mb: 2 } }
            >
              { /* Titolo facoltativo per la sezione Consuntivazioni */ }
            </Typography>
            <AddSkillBookTemplate closeModal={ closeModal } />
          </Box>
        ) }
      </Box>
    </>
  );
};

export default ExternalTrainingModal;
